import CaretBlueUrl from '@/assets/svg/caret-blue.svg?raw';
import ChevronUrl from '@/assets/svg/chevron.svg?raw';
import { svgUriEncoder } from '@/utils';
import { css, unsafeCSS } from 'lit';

export const formStyles = css`
  :host([part='wholesale']) input,
  :host([part='wholesale']) select {
    font-size: 1rem;
    color: var(--fg-primary);
    height: 48px;
    border: 1px solid var(--fg-gray--300);
    box-shadow: none;
    padding: 0 16px;
    transition: border-color ease-in-out 0.3s;
  }

  :host([part='wholesale']) input,
  :host([part='wholesale']) select {
    color: var(--fg-text, var(--fg-fallback-text));
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 4px 0px inset;
    border: 1px solid var(--fg-gray--500, var(--fg-fallback-gray--500));
  }

  :host([part='retail']) input:focus-visible {
    outline: var(--fg-primary, var(--fg-fallback-primary)) auto 1px;
  }

  :host([part='wholesale'])select {
    padding: 0 26px 0 16px;
  }

  :host([part='wholesale']) input:focus-visible,
  :host([part='wholesale'])select:focus-visible {
    outline: var(--fg-secondary) auto 1px;
  }

  :host([part='wholesale']) input::placeholder,
  :host([part='wholesale']) input:disabled::placeholder,
  :host([part='wholesale']) textarea::placeholder {
    color: var(--fg-gray--500);
  }

  :host([part='wholesale'])textarea {
    border: 1px solid var(--fg-gray--300);
    line-height: 140%;
    box-shadow: none;
    padding: 16px;
  }

  :host([part='wholesale']) input.invalid {
    animation-name: invalid-blink;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
  }

  :host([part='wholesale']) input.warning {
    border: 1px solid var(--fg-warning, var(--fg-fallback-warning));
  }

  :host([part='wholesale']) input.warning:focus-visible {
    outline: var(--fg-warning, var(--fg-fallback-warning)) auto 1px;
  }

  :host([part='wholesale']) input:focus-visible {
    outline: var(--fg-success, var(--fg-fallback-success)) auto 1px;
  }

  select,
  input[list] {
    appearance: none;
    background-image: url(${unsafeCSS(svgUriEncoder(ChevronUrl))});
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: right 10px center;
    cursor: pointer;
  }

  :host select,
  :host input[list] {
    background-image: url(${unsafeCSS(svgUriEncoder(CaretBlueUrl))});
    background-size: 11px;
  }

  input[readonly] {
    background-color: var(--fg-gray--100, var(--fg-fallback-gray--100));
    color: var(--fg-gray--500, var(--fg-fallback-gray--500));
  }

  input,
  select {
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
    font-size: 1rem;
    color: #000;
    height: 37px;
    border: 1px solid var(--fg-gray--500, var(--fg-fallback-gray--500));
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    box-shadow: 0px 2px 4px 0px #00000026 inset;
    padding: 0 10px;
  }

  input:disabled {
    background: var(--fg-gray--300, var(--fg-fallback-gray--300));
  }

  input:disabled::placeholder {
    color: var(--fg-gray--500, var(--fg-fallback-gray--500));
  }

  textarea {
    font-family: var(
      --fg-font-family--serif,
      var(--fg-fallback-font-family--serif)
    );
    border: 1px solid var(--fg-gray--500, var(--fg-fallback-gray--500));
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    font-size: 1rem;
    line-height: 1.1875rem;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15);
    min-height: 88px;
    resize: none;
    padding: 10px;
    margin-bottom: 15px;
  }

  textarea::placeholder {
    color: var(--fg-gray--600, var(--fg-fallback-gray--600));
  }

  @keyframes invalid-blink {
    0% {
      border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
    }
    50% {
      border: 1px solid var(--fg-error);
    }
    100% {
      border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
    }
  }
`;
